module.exports = __webpack_public_path__ + "static/media/andimar-offices-banner.5898551f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/favoriteDestinations/andimar-offices-banner.jpg
// module id = 295
// module chunks = 0